import { object, string } from "yup";

export const getValidation = () => {
  const validationSchema = object().shape({
    username: string()
      .required()
      .default(""),
    password: string()
      .required()
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
